<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<!-- start detail -->
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs12>
						<ValidationProvider
							name="name"
							v-slot="{ errors, valid }"
						>
							<form-localized-input
								v-model="item.name"
								:errors="errors"
								:valid="valid"
							>
							</form-localized-input>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12>
						<ValidationProvider
							name="parent_idd"
							v-slot="{ errors, valid }"
						>
							<v-autocomplete
								:label="$t('Parent')"
								v-model="item.parent_id"
								:errors="errors"
								:valid="valid"
								:items="parent"
								item-value="id"
								item-text="name"
							>
							</v-autocomplete>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12>
						<ValidationProvider
							name="description"
							v-slot="{ errors, valid }"
						>
							<form-localized-editor
								v-model="item.description"
								:errors="errors"
								:valid="valid"
							>
							</form-localized-editor>
						</ValidationProvider>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4>
				<v-card>
					<v-card-title primary-title>
						<h3>{{ $t("label.image") }}</h3>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<app-media-library
							v-model="item.image"
						></app-media-library>
					</v-card-text>
				</v-card>
			</v-flex>
			<!-- end detail -->

			<!-- start module setting -->
			<v-flex xs12>
				<v-card
					><v-system-bar color="grey darken-4" height="10">
					</v-system-bar>
					<v-card-title primary-title>
						{{ $t("Module Setting") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12 md4>
								<v-switch
									v-model="item.settings.delivery_module"
									:label="$t('Delivery Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md4>
								<v-switch
									v-model="item.settings.pickup_module"
									:label="$t('Pickup Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md4>
								<v-switch
									v-model="item.settings.dine_in_module"
									:label="$t('Dinein Module')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-switch
									v-model="item.settings.is_free_flow"
									:label="$t('Is Free-flow')"
								></v-switch>
							</v-flex>
							<v-flex xs12 md3>
								<v-text-field
									type="number"
									v-model="item.settings.free_flow_price"
									:label="$t('Free-flow price')"
									prepend-inner-icon="mdi-currency-usd"
									min="0"
								></v-text-field>
							</v-flex>
							<v-flex xs12 md3>
								<v-text-field
									type="number"
									v-model="item.settings.free_flow_limit"
									:label="$t('Free-flow limit pax')"
									prepend-inner-icon="mdi-account"
									min="1"
								></v-text-field>
							</v-flex>
							<v-flex xs12 md3>
								<v-select
									v-model="item.settings.free_flow_product_id"
									:label="$t('Free Flow Product')"
									:items="products"
									item-value="id"
									item-text="name" 
									clearable
								>
								</v-select>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
			<!-- end module setting -->

			<!-- schedule setting -->
			<v-flex xs12>
				<v-card
					><v-system-bar color="grey darken-4" height="10">
					</v-system-bar>
					<v-card-title primary-title>
						{{ $t("Schedule Setting") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<schedule-component
							v-model="item.schedule"
						></schedule-component>
					</v-card-text>
				</v-card>
			</v-flex>
			<!-- end schedule setting -->
		</v-layout>
	</v-container>
</template>

<script>
import ScheduleComponent from "@Shop/components/ScheduleComponent";
export default {
	props: ["value", "parent", "products"],
	components: {
		ScheduleComponent,
	},
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>